import { MessageFileType } from 'enums/MessageFileType';
import { MediaInfo } from 'interfaces/MediaInfo';
import { randomUuid } from 'utils/random';

export const enum FileActionType {
    SetAllowedExtensions = 'FILES/SET_ALLOWED_EXTENSIONS',
    UploadFile = 'FILES/UPLOAD_FILE',
    FileUploadProgress = 'FILES/UPLOAD_PROGRESS',
    SetFileUploadSize = 'FILES/SET_UPLOAD_SIZE',
    FileUploaded = 'FILES/FILE_UPLOADED',
    FileNotUploaded = 'FILES/FILE_NOT_UPLOADED',
    ClearFile = 'FILES/CLEAR_FILE',
    ClearFiles = 'FILES/CLEAR_FILES',
}

export type SetAllowedFileExtensionsAction = ReturnType<typeof setAllowedFileExtensions>;
export const setAllowedFileExtensions = (extensions: string[]) => ({
    type: FileActionType.SetAllowedExtensions,
    payload: extensions,
});

export type UploadFileAction = ReturnType<typeof uploadFile>;
export const uploadFile = (file: File, uuid = randomUuid()) => ({
    type: FileActionType.UploadFile,
    payload: { file, uuid },
});

export type FileUploadProgressAction = ReturnType<typeof fileUploadProgress>;
export const fileUploadProgress = (uuid: string, progress: number) => ({
    type: FileActionType.FileUploadProgress,
    payload: { uuid, progress },
});

export type SetFileUploadSizeAction = ReturnType<typeof setFileUploadSize>;
export const setFileUploadSize = (uuid: string, size: number) => ({
    type: FileActionType.SetFileUploadSize,
    payload: { uuid, size },
});

export type FileUploadedAction = ReturnType<typeof fileUploaded>;
export const fileUploaded = (uuid: string, type: MessageFileType, info: MediaInfo) => ({
    type: FileActionType.FileUploaded,
    payload: { uuid, type, info },
});

export type FileNotUploadedAction = ReturnType<typeof fileNotUploaded>;
export const fileNotUploaded = (
    uuid: string,
    reason = 'Не удалось загрузить файл',
    badFile = false,
) => ({
    type: FileActionType.FileNotUploaded,
    payload: { uuid, reason, badFile },
});

export type ClearFileAction = ReturnType<typeof clearFile>;
export const clearFile = (uuid: string) => ({
    type: FileActionType.ClearFile,
    payload: uuid,
});

export type ClearFilesAction = ReturnType<typeof clearFiles>;
export const clearFiles = () => ({
    type: FileActionType.ClearFiles,
});
